import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'

import Slider from 'react-slick'

const sliderConfig = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  draggable: false,
  autoplaySpeed: 4000,
  cssEase: 'ease-out'
}

// NOTE: Slider needs an extra wrapper div inside which we cannot attach layout to,
// because it conflicts with slick's layout classes (float etc)
const Carousel = class Carousel extends Component {
  constructor () {
    super()
    this.state = {
      initialized: false
    }
  }
  componentDidMount () {
    this.setState({ initialized: true })
  }
  render () {
    const { extraClass, slides, sliderOptions, slideRenderFn } = this.props
    if (!slides) {
      return null
    }

    const options = Object.assign(
      {},
      sliderConfig,
      {
        dots: slides.length > 1,
        autoplay: slides.length > 1
      },
      sliderOptions
    )

    const classes = classnames(
      {
        'carousel--initialized': this.state.initialized,
        'carousel--with-dots': options.dots
      },
      extraClass,
      'carousel'
    )

    return (
      <div className={classes}>
        <Slider {...options}>
          {slides.map((slide, idx) => (
            <div key={idx}>{slideRenderFn(slide)}</div>
          ))}
        </Slider>
      </div>
    )
  }
}

Carousel.propTypes = {
  extraClass: PropTypes.string,
  slides: PropTypes.array.isRequired,
  slideRenderFn: PropTypes.func,
  sliderOptions: PropTypes.object
}

export default Carousel



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Carousel.js